var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6472_41536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5C3.36433 0.5 0 3.86433 0 8C0 12.1357 3.36433 15.5 7.5 15.5C11.6357 15.5 15 12.1357 15 8C15 3.86433 11.6357 0.5 7.5 0.5Z",
    fill: "#009262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3014 6.4108L7.23888 10.4732C7.117 10.5951 6.95702 10.6564 6.79703 10.6564C6.63704 10.6564 6.47705 10.5951 6.35517 10.4732L4.32396 8.44201C4.07951 8.19768 4.07951 7.80263 4.32396 7.5583C4.56829 7.31385 4.96323 7.31385 5.20767 7.5583L6.79703 9.14765L10.4177 5.52708C10.662 5.28264 11.057 5.28264 11.3014 5.52708C11.5458 5.77142 11.5458 6.16635 11.3014 6.4108Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6472_41536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.13a5f8a3271bc68cffb8090dc8023a3e.svg";
export { ForwardRef as ReactComponent };